export const LIMIT = 20;
export const TAG_985 = '985';
export const TAG_211 = '211';
export const TAG_MEMBEROF = '教育部直属';
export const BRANCH_LIST=[{name:'文科',code:'10'},{name:'理科',code:'20'}];
export const NEW_BRANCH_LIST=[
    {name:'物理类',code:'30'},
    {name:'历史类',code:'40'},
    {name:'综合类',code:'50'},
    {name:'艺术类',code:'60'},
    {name:'艺术文',code:'61'},
    {name:'艺术理',code:'62'},
    {name:'体育类',code:'70'},
    {name:'体育文',code:'71'},
    {name:'体育理',code:'72'},
];
export const BATCH_UNDERGRADUATE_LIST=[
    {name:'本科提前批',code:'0'},
    {name:'本科一批',code:'1'},
    {name:'本科二批',code:'2'},
    {name:'本科三批',code:'3'},
    {name:'本科提前批A段',code:'8'},
    {name:'本科提前批B段',code:'9'},
    {name:'本科批',code:'10'},
    {name:'国家专项计划本科批',code:'11'},
    {name:'地方专项计划本科批',code:'12'},
    {name:'高校专项计划本科批',code:'13'},
];
export const BATCH_JUNIOR_LIST=[
    {name:'专科一批',code:'4'},
    {name:'专科二批',code:'5'},
    {name:'专科提前批',code:'6'},
    {name:'专科批',code:'7'},
];
export const TYPE_UNDERGRADUATE = 20
export const TYPE_COLLEGE = 10
export const CAT_UNDERGRADUATE = 3
export const CAT_COLLEGE = 2



// WEBPACK FOOTER //
// ./src/pages/School/constants/index.js